import type { ComponentProps } from "react";
import { HiGif } from "react-icons/hi2";

import { DIALOG } from "@/components/app/dialogs/dialog-provider";
import { useLocalEntryDialog } from "@/components/app/dialogs/use-local-entry-dialog";
import { GifSearch } from "@/components/shared/gif-search/gif-search";
import { Button } from "@/components/ui/button";

import { useEditorFieldContext } from "../editor-context";

export const EditorActionGif = (props: ComponentProps<typeof Button>) => {
  const { setEditorValue } = useEditorFieldContext<"body">();
  const { open: gifSearchOpen, setOpen: setGifSearchOpen } =
    useLocalEntryDialog(DIALOG.GifSearch);

  return (
    <>
      <Button
        {...props}
        onClick={() => {
          setGifSearchOpen(true);
        }}
      >
        <HiGif className="text-lg" />
      </Button>
      <GifSearch
        open={gifSearchOpen}
        onSelect={(gif) => {
          setEditorValue((prev) => `${prev}\n\n![GIF](${gif})`.trim());
          setGifSearchOpen(false);
        }}
        onOpenChange={setGifSearchOpen}
      />
    </>
  );
};
